/**
 * Enhanced Wishlist functionality with grouped support
 * 
 * This script provides backward compatibility for legacy wishlist functionality
 * while supporting the new grouped wishlist system. The main product page now
 * uses a modal for group selection, but this script maintains support for
 * direct add-to-wishlist functionality where needed.
 */
(function () {
  
  // Legacy wishlist functionality for backward compatibility
  const initLegacyWishlist = function () {
    try {
      // Look for legacy wishlist buttons (not using the new modal system)
      const legacyButtons = document.querySelectorAll(".momo-wishlist-button:not([aria-haspopup='dialog'])");
      
      legacyButtons.forEach(button => {
        if (button.dataset.initialized) return; // Skip if already initialized
        button.dataset.initialized = 'true';
        
        button.addEventListener("click", function (event) {
          event.preventDefault();
          
          const productId = button.dataset.productId;
          const sectionId = button.dataset.sectionId;

          console.log("Legacy wishlist - productId:", productId);
          console.log("Legacy wishlist - sectionId:", sectionId);

          // Store original state
          const originalText = button.textContent || "Add to Wishlist";
          const wasDisabled = button.disabled;

          // Set loading state
          button.disabled = true;
          button.textContent = "Adding...";

          // Use the grouped API but without specifying a group (defaults to "Ungrouped")
          const url = `/apps/momo/api/wishlist?product_id=${encodeURIComponent(productId)}`;

          loader
            .put(url)
            .then(function (response) {
          
              
              // Verify button still exists before updating
              if (!button || !button.parentNode) {
                console.error("Button no longer exists in DOM");
                return;
              }
              
              // Check if the response indicates success
              if (response.productAdded === true) {
                // Product was successfully added
                button.textContent = "Added to Wishlist!";
                button.disabled = true;
                button.classList.add('added-to-wishlist'); 
                
                showToast(response.message || "Product added to wishlist!", "success");
                
              } else if (response.productAdded === false) {
                // Product already in wishlist
                button.textContent = "Already in Wishlist";
                button.disabled = true;
                button.classList.add('already-in-wishlist');
                
                showToast(response.message || "Product is already in your wishlist!", "warning");
                
              } else if (response.error) {
                // Server returned an error
                console.error("Server error:", response.error);
                resetButton(button, originalText, wasDisabled);
                
                showToast(response.error, "error");
                
              } else {
                // Unexpected response format
                console.error("Unexpected response format:", response);
                resetButton(button, originalText, wasDisabled);
                
                showToast("Unexpected response from server", "error");
              }
            })
            .catch(function (error) {
              console.error("Network or parsing error:", error);
              
              // Verify button still exists before resetting
              if (button && button.parentNode) {
                resetButton(button, originalText, wasDisabled);
              }
              
              showToast("Error adding product to wishlist. Please try again.", "error");
            });
        });
      });
    } catch (error) {
      console.error("Error during legacy wishlist initialization:", error);
    }
  };

  // Utility functions
  function resetButton(button, originalText, wasDisabled) {
    if (button && button.parentNode) {
      try {
        button.textContent = originalText;
        button.disabled = wasDisabled;
        button.classList.remove('added-to-wishlist', 'already-in-wishlist');
      } catch (e) {
        console.error("Error resetting button:", e);
      }
    }
  }

  function showToast(message, type = 'info') {
    if (!window.Toastify) {
      console.log('Toast message:', message);
      return;
    }

    const styles = {
      success: { background: "#657457 !important", color: "#fff" },
      warning: { background: "#000 !important", color: "#000" },
      error: { background: "#000 !important", color: "#fff" },
      info: { background: "#000 !important", color: "#fff" }
    };

    Toastify({
      text: message,
      duration: type === 'error' ? 4000 : 3000,
      close: true,
      gravity: "top",
      position: "right",
      stopOnFocus: true,
      style: {
        ...styles[type],
        borderRadius: "5px",
        padding: "10px 20px",
      },
    }).showToast();
  }

  // Make showToast globally available
  window.showToast = showToast;

  // API helper functions for grouped wishlist operations
  window.WishlistAPI = {
    /**
     * Add product to a specific group
     */
    async addToGroup(productId, groupId, customerId) {
      try {
        const url = `/apps/momo/api/wishlist?product_id=${encodeURIComponent(productId)}&group_id=${encodeURIComponent(groupId)}&logged_in_customer_id=${encodeURIComponent(customerId)}&shop=${encodeURIComponent(window.Shopify?.shop || '')}`;
        
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error adding to group:', error);
        throw error;
      }
    },

    /**
     * Create a new wishlist group
     */
    async createGroup(groupName, customerId) {
      try {
        const url = `/apps/momo/api/wishlist/groups?action=create&logged_in_customer_id=${encodeURIComponent(customerId)}&shop=${encodeURIComponent(window.Shopify?.shop || '')}`;
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name: groupName })
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error creating group:', error);
        throw error;
      }
    },

    /**
     * Get all wishlist groups
     */
    async getGroups(customerId) {
      try {
        const url = `/apps/momo/api/wishlist/groups?action=list&logged_in_customer_id=${encodeURIComponent(customerId)}&shop=${encodeURIComponent(window.Shopify?.shop || '')}`;
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error fetching groups:', error);
        throw error;
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLegacyWishlist);
  } else {
    initLegacyWishlist();
  }

  // Re-initialize when new content is added (for AJAX-loaded content)
  document.addEventListener('wishlist:reinit', initLegacyWishlist);

})();